import { useEffect, useState } from "react";

/**
 * Returns false during SSR and the first client render, then true after
 * mount. Gate client-only reads (e.g. sessionStorage) on this so the first
 * client render matches the server shell and avoids a hydration mismatch.
 */
export default function useIsMounted(): boolean {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return mounted;
}
